import { useCallback, useEffect, useState } from "react";
import { validationErrorMessage } from "./patientFormRules";

export default function usePatientValidation({ onValidatePatient, patients, selectedIdx }) {
    const [validatingPatientKey, setValidatingPatientKey] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        setError(null);
    }, [selectedIdx]);

    const validateSelectedPatient = useCallback(async () => {
        if (!onValidatePatient || !patients[selectedIdx]) return;
        const patient = patients[selectedIdx];
        const patientKey = patient._clientKey || patient.commandePatientId || patient.id || selectedIdx;
        setValidatingPatientKey(patientKey);
        setError(null);
        try {
            await onValidatePatient(patient);
        } catch (err) {
            setError(validationErrorMessage(err));
        } finally {
            setValidatingPatientKey(null);
        }
    }, [onValidatePatient, patients, selectedIdx]);

    return { validating: validatingPatientKey !== null, error, validateSelectedPatient };
}
